import { gql } from "@apollo/client";
import CompanySubscription from "~/lib/queries/fragments/CompanySubscription";
import StripeChargeFields from "~/lib/queries/fragments/StripeChargeFields";

export default gql`
  mutation CancelSubscription {
    cancelSubscription {
      ...CompanySubscription
    }
  }

  ${CompanySubscription}
  ${StripeChargeFields}
`;
